export default __webpack_public_path__ + "static/facebook-6700caa9e554270987053f089c14533a.svg";